<div class="stepbox">
    <ol class="stepbystep">
        <li [ngClass]="{'current': stepIndex == 0}" i18n>Fill profile</li>
        <li [ngClass]="{'current': stepIndex == 1}" i18n>Select GEDCOM</li>
        <li [ngClass]="{'current': stepIndex == 2}" i18n>Select design</li>
        <li [ngClass]="{'current': stepIndex == 3}" i18n>Build Your Tree!</li>
    </ol>
</div>
<div class="content">

    <app-profile-form [inWizard]="true" *ngIf="stepIndex == 0" (updateEvent)="next($event)"></app-profile-form>
    <app-wizard-gedcom *ngIf="stepIndex == 1" (gedcomEvent)="selectedGedcom($event)"></app-wizard-gedcom>
    <app-wizard-tree-selection [gedcomId]="selectedGedcomId" *ngIf="stepIndex == 2"></app-wizard-tree-selection>
</div>

<button i18n class="btn-green" *ngIf="stepIndex > 0" (click)="back()">Back</button>